// Quick function for creating dom elements. Stolen shamelessly from Eloquent JavaScript:
// https://eloquentjavascript.net/16_game.html#domdisplay

export function elt(name, attrs, ...children) {
  let dom = document.createElement(name);

  if (attrs) {
    for (let attr of Object.keys(attrs)) {
      dom.setAttribute(attr, attrs[attr]);
    }
  }

  for (let child of children) {
    if (typeof child != 'string') {
      dom.appendChild(child);
    }
    else {
      dom.appendChild(document.createTextNode(child));
    }
  }
  return dom;
}

export function removeAllChildren(node) {
  if (!node) {
    return;
  }

  while (node.firstChild) {
    node.removeChild(node.firstChild);
  }
}
